import React from 'react'
import PropTypes from 'prop-types'
import cc from 'classcat'

const HintLabel = (props) => {
  const { thickness, children, size, hintClass } = props
  return (
    <div
      className={ cc([hintClass, "o-hint-text"]) }
      style={ { fontSize: size, fontWeight: thickness } }>
      { children }
    </div>
  )
}

HintLabel.propTypes = {
  size: PropTypes.number,
  thickness: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  children: PropTypes.node.isRequired,
  hintClass: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
}
HintLabel.defaultProps = {
  size: 24,
  thickness: 'normal',
  hintClass: [],
}

export default HintLabel
